import { delay, put, takeEvery } from 'redux-saga/effects';
import * as actions from 'containers/PageHeader/Groups/store/actions';
import { CREATE_GROUP_FINISH } from 'containers/PageHeader/Groups/store/action-types';

function* finishGroupSaga() {
  yield delay(3000);
  yield put(actions.setShow(false));
}

export default function* createEditCGroupSagas() {
  yield takeEvery(CREATE_GROUP_FINISH as any, finishGroupSaga);
}
